export default {
  OpenPitCost: 0, 
  UndergroundCost: 1,
  HeapLeachCost: 2,
  MillCost: 3,
  SiteCost: 4,
  SustainingCapital: 5,
  GrowthCapital: 6
};